export default "__VITE_ASSET__DLTEZkcE__"